import BaseComponent from '../base-component/base-component'
import { Nullable } from '../../types/common'
import { getTemplateContent } from '../../utils/dom'

class ShareWrapper extends BaseComponent {
  systemDefaultTemplate: Nullable<HTMLTemplateElement>
  customTemplate: Nullable<HTMLTemplateElement>

  constructor() {
    super()

    this.customTemplate = this.querySelector('[data-share-custom-template]')
    this.systemDefaultTemplate = this.querySelector(
      '[data-share-system-default-template]',
    )
  }

  connectedCallback(): void {
    this.init()
  }

  init(): void {
    const template = navigator.share
      ? this.systemDefaultTemplate
      : this.customTemplate

    const node = getTemplateContent(template)

    this.appendChild(node)
  }
}

export default ShareWrapper
